import { render, staticRenderFns } from "./BindSchoolList.vue?vue&type=template&id=4a1365ca&"
import script from "./BindSchoolList.vue?vue&type=script&lang=ts&"
export * from "./BindSchoolList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports